export default "/static/js/bin/images/ca9a5975081039337b7be4ccb866e5f9.mp4";